module.exports = __webpack_public_path__ + "img/art1_header.4551a8a2.png";